import axios from 'axios';
import snackBarService from '@/shared/snackbar/snackbar.service';
import EventError from './event-error.entity';

export default class EventErrorService {
  searchAllErrorsDetails(idProject: string, idAggregator: string): Promise<EventError[]> {
    return axios
      .get(`/events/aggregators/${idProject}/${idAggregator}`)
      .then((response: EventError[]) => EventError.ofList(response))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  reprocess(idEventError:string): Promise<EventError[]> {
    return axios
      .post(`/events/error/reprocess/${idEventError}`)
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  reprocessSelectedErrors(idEventErrorList: string[]): Promise<EventError[]> {
    return axios
      .post('/events/error/reprocess-selected', idEventErrorList)
      .then(() => snackBarService.successMessage('Errors reprocessed successfully'))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  reprocessAndDeleteError(idEventError:string): Promise<void> {
    return axios
      .post(`/events/error/reprocess-error/${idEventError}`);
  }
}
